export type Buyer = { name: string; country: string };

export const buyers: Buyer[] = [
  { name: "María Fernanda G.", country: "Mexico" },
  { name: "Dr. Alejandro R.", country: "Colombia" },
  { name: "Valentina S.", country: "Argentina" },
  { name: "Dr. Javier M.", country: "Spain" },
  { name: "Camila P.", country: "Chile" },
  { name: "Dr. Andrés L.", country: "Peru" },
  { name: "Lucía H.", country: "Uruguay" },
  { name: "Dr. Mateo V.", country: "Ecuador" },
  { name: "Daniela C.", country: "Costa Rica" },
  { name: "Dr. Sebastián T.", country: "Guatemala" },
  { name: "Gabriela N.", country: "Dominican Republic" },
  { name: "Dr. Ricardo O.", country: "Venezuela" },
  { name: "Isabella F.", country: "Panama" },
  { name: "Dr. Diego A.", country: "Bolivia" },
  { name: "Paula E.", country: "Paraguay" },
  { name: "Dr. Fernando J.", country: "Puerto Rico" },
  { name: "Natalia B.", country: "El Salvador" },
  { name: "Dr. Carolina Q.", country: "Honduras" },
];
